<template>
    <div id="container-wrap-popup">
        <div id="popup-dimmed-bg" v-on:click.self="handleClickClose">
            <div id="changepassword-popup-container">
                <img src="@/assets/popup/pai/img-close-icon.svg" class="close-icon" v-if='false' v-on:click='handleClickClose'>

                <div class="changepassword-popup-info">
                    <div class="popup-text">{{l10.All_Parents_ChangePassword_Title}}</div>
                    <div class="popup-text small">{{l10.All_Parents_ChangePassword_Desc}}</div>
                    <div class="inputs">
                        <input type="password" ref="oldpassword" class='password' v-model="oldpassword" :placeholder='l10.All_Parents_ChangePassword_Input1'>
                        <input type="password" ref="newpassword" class='password' v-model="newpassword" :placeholder='l10.All_Parents_ChangePassword_Input2'>
                        <input type="password" ref="newpassword_check" class='password' v-model="newpassword_check" :placeholder='l10.All_Parents_ChangePassword_Input3'>
                    </div>
                </div>
                <div id="check-button" v-on:click='handleConfirmClick'>
                    <input class="red-btn-popup" type="button" :value='l10.All_Parents_ChangePassword_Button'>
                </div>
                <div class="change-later" v-on:click='handleLaterClick'>{{l10.All_Parents_ChangePassword_Button_Later}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        const text = require("../../text/parent/laptop.js").default;
        const l10n = text[this.$store.state.lang]
            ? text[this.$store.state.lang]
            : text["en"];
        return {
            l10:l10n,
            oldpassword: '',
            newpassword: '',
            newpassword_check: '',
            env: this.$store.state.env,
        }
    },
    mounted() {
        document.body.style.overflow = 'hidden'
    },
    beforeDestroy() {
        document.body.style.overflow = ''
    },
    methods: {
        handleClickClose() {
            // this.$emit('close-popup')
        },

        handleConfirmClick() {
            if (this.$store.getters.accountId == null) {
                this.$emit('show-message', 'needlogin')
                return
            }

            var engRegExp = /[A-Za-z]/
            var numRegExp = /[0-9]/

            if (this.oldpassword == '') {
                // this.$emit('show-message', this.l10.All_Parents_ChangePassword_Message2)
                return
            } else if(this.newpassword == '') {
                // this.$emit('show-message', this.l10.All_Parents_ChangePassword_Message3)
                return
            } else if(this.newpassword != this.newpassword_check) {
                this.$emit('show-message', this.l10.All_Parents_Signup_Title1_ErrorMessage2)
                return
            } else if(this.oldpassword == this.newpassword) {
                this.$emit('show-message', this.l10.All_Parents_Signup_Title1_ErrorMessage3)
                return
            } else if (this.newpassword.length < 6) {
                this.$emit('show-message', this.l10.All_Parents_Signup_Title1_ErrorMessage4)
                return
            } else if (!engRegExp.test(this.newpassword) || !numRegExp.test(this.newpassword)) {
                this.$emit('show-message', this.l10.All_Parents_Signup_Title1_ErrorMessage4)
                return
            }

            for (var i=0; i<this.newpassword.length; i++) {
                var code = this.newpassword.charCodeAt(i)
                if (code < 32 || code > 255) {
                    this.$emit('show-message', this.l10.All_Parents_Signup_Title1_ErrorMessage4)
                    return
                }
            }

            const self = this;
            this.axios.post(
                this.env.protocol + this.env.urlAPI + "/account/changePassword",
                {
                    accountId: this.$store.getters.accountId,
                    password: this.oldpassword,
                    newPassword: this.newpassword,
                    installId: "installId"
                }
            ).then(function (res) {
                if (!res.data.result) {
                    var errCode = res.data.errorCode
                    if ( "All_Parents_Error_" + errCode in self.l10) {
                        self.$emit('show-message', self.l10["All_Parents_Error_" + errCode])
                    } else {
                        self.$emit('show-message', "Unknown error occurred.")
                    }
                } else {
                    self.$emit('change-complete')
                    // self.products = res.data.data.products
                    // self.popMsg('OK');
                }
            }).catch(function (err) {
                self.$emit('show-message', 'Unknown error occurred.')
            });
        },

        handleLaterClick() {
            if (this.$store.getters.accountId == null) {
                this.$emit('show-message', 'needlogin')
                return
            }

            const self = this;
            this.axios.post(
                this.env.protocol + this.env.urlAPI + "/account/changePasswordLater",
                {
                    accountId: this.$store.getters.accountId,
                    // product: "todoenglish"
                }
            ).then(function (res) {
                if (!res.data.result) {
                    var errCode = res.data.errorCode
                    if (errCode == 'CA01') {
                        self.$emit('show-message', errCode)
                    } else if ( "All_Parents_Error_" + errCode in self.l10) {
                        self.$emit('show-message', self.l10["All_Parents_Error_" + errCode])
                    } else {
                        self.$emit('show-message', "Unknown error occurred.")
                    }
                } else {
                    self.$emit('change-later')
                    // self.products = res.data.data.products
                    // self.popMsg('OK');
                }
            }).catch(function (err) {
                self.$emit('show-message', 'Unknown error occurred.')
            });
        },


    }
}
</script>
<style scoped>
input::-webkit-input-placeholder,
input:-ms-input-placeholder,
input::placeholder {
  font-size: 14px;
}

#popup-dimmed-bg {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);

    position: fixed;
    top: 0;
}

#container-wrap-popup {
    position: fixed;
    z-index: 2000;
    height: 100%;
    width: 100%;
}

#changepassword-popup-container {
    width: 436px;
    /* height: 326px; */
    border-radius: 14px;
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05);
    border: solid 1px #f2f2f2;
    background-color: #ffffff;
    padding: 12px;
    margin: 0 auto;

    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -218px;
    margin-top: -210px;
    padding-bottom: 20px;
}

.changepassword-popup-info {
    text-align: center;
    margin: 0 auto;
}

.popup-text {
    font-size: 22px;
    line-height: 1.75;
    letter-spacing: -0.5px;
    margin-top: 20px;
    text-align: center;
}

.popup-text.small {
    font-size: 16px;
    width: 250px;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 10px;
    /* padding-left: 0px; */
    line-height: 1.5;
}

.changepassword-popup-info .inputs {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.changepassword-popup-info input {
    width: 240px;
    margin-top: 12px;
    border: 1px solid #AAA;
    border-radius: 6px;
    padding: 12px;
}

#check-button {
    margin-top: 30px;
    text-align: center;
}

.red-btn-popup {
    width: 240px;
    height: auto;
    background-image: none;
    background-color: #42c0ff;
    font-size: 18px;
    padding: 12px;
    border-radius: 12px;
    color: #fff;
    border: none;
    cursor: pointer;
    font-weight: 700;
}

.change-later {
    margin-top: 15px;
    font-size: 13px;
    text-decoration: underline;
    color: #AAA;
    text-align: center;
    cursor: pointer;
}

input {
    -webkit-appearance: none;
}

@media screen and (max-width: 720px) {
    input::-webkit-input-placeholder,
    input:-ms-input-placeholder,
    input::placeholder {
      font-size: 28px;
    }

    #container-wrap-popup {
        margin: 0 auto;
    }

    #changepassword-popup-container {
        width: 590px;
        height: auto;
        border-radius: 24px;
        box-shadow: 0 4px 32px 0 rgba(0, 0, 0, 0.05);
        padding: 32px;
        margin: 0 auto;

        position: fixed;
        top: 50%;
        left: 50%;
        margin-left: -290px;
        margin-top: -390px;
    }

    .changepassword-popup-info {
        text-align: center;
    }

    .popup-text {
        line-height: 1.64;
        letter-spacing: -1px;
        margin-top: 30px;
        font-size: 42px;
    }

    .popup-text.small {
        font-size: 30px;
        width: 470px;
        margin: 0 auto;
        margin-top: 10px;
        margin-bottom: 10px;
        line-height: 1.5;
    }

    .changepassword-popup-info .inputs {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .changepassword-popup-info input {
        width: 90%;
        margin-top: 20px;
        border: 1px solid #AAA;
        border-radius: 12px;
        padding: 24px;
        font-size: 28px;
    }

    #check-button {
        margin-top: 50px;
        margin-bottom: 30px;
    }

    .red-btn-popup {
        height: auto;
        background-image: none;
        background-color: #42c0ff;
        font-size: 30px;
        padding: 25px;
        border-radius: 24px;
        width: 90%;
    }

    .change-later {
        font-size: 24px;
    }

}

</style>



// WEBPACK FOOTER //
// src/pages/account/ChangePassword.vue